import {
  AuthenticationResult,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';
import { getMsalConfig } from './msal';

const params = new URLSearchParams(window.location.search);
const loginType = params.get('type');

export const msalInstance = new PublicClientApplication(
  getMsalConfig(loginType),
);

if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
  const authenticationResult = event.payload as AuthenticationResult | null;
  const isSuccessfulAuthentication =
    event.eventType === EventType.LOGIN_SUCCESS ||
    event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
    event.eventType === EventType.SSO_SILENT_SUCCESS;

  if (isSuccessfulAuthentication && authenticationResult?.account) {
    msalInstance.setActiveAccount(authenticationResult.account);
  }
});
